<template>
  <section id="blog" class="news-container">
    <div class="container pb-50 pt-0" data-aos="fade-left" data-aos-delay="300">
      <div class="section-title text-center">
        <div class="row">
          <div class="col-md-12 col-md-offset-2">
            <h2 class="mt-0 line-height-1">
              Berita
              <span class="text-theme-colored">Terbaru</span>
            </h2>
          </div>
        </div>
      </div>
      <div class="row mt-30">
        <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <div v-else-if="articles.length < 1" class="col-md-12 alert alert-danger">No data</div>
        <div v-else class="col-md-12">
          <carousel
            :autoplay="false"
            :nav="true"
            :items="(articles.length > 3) ? 3 : articles.length"
            :loop="false"
            :dots="false"
            :margin="15"
            :responsive="{
					  	1024:{items:3},
					  	639:{items:2},
					  	0:{items:1}
					  }"
          >
            <div v-bind:key="item.id" v-for="item in articles" class="item">
              <article class="post clearfix maxwidth600 mb-30">
                <div class="entry-header">
                  <div class="post-thumb thumb">
                    <img
                      class="news-img img-responsive img-fullwidth"
                      v-bind:src="((item.image == null || item.image == '-' || item.image == '')) ? require('../../assets/no-image.jpg') : item.image"
                      alt
                    />
                  </div>
                </div>
                <div class="bg-theme-colored2 p-15 pt-10 pb-10">
                  <span class="mb-10 text-white mr-10 font-13">
                    <i class="fa fa-calendar mr-5 text-white"></i>
                    {{ item.created_at }}
                  </span>
                </div>
                <div class="entry-content bg-lighter p-20 pr-10">
                  <div class="entry-meta mt-0 no-bg no-border">
                    <div class="event-content">
                      <h3 class="entry-title text-white text-capitalize m-0">
                        <a href="#">{{ item.title.substr(0, 50) + '...' }}</a>
                      </h3>
                    </div>
                  </div>
                  <p class="mt-10">{{ item.description.substr(0, 90) + '...' }}</p>
                  <div class="mt-10">
                    <b-link
                      class="btn btn-flat btn-theme-colored btn-circled mt-15 text-theme-color-2"
                      :to="{ 
											name: 'berita-detail', 
											params: { 
												slug: item.slug,
											} 
										}"
                    >Read more</b-link>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </article>
            </div>
          </carousel>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";
import api from "../../services/api";

export default {
  components: { carousel },
  data() {
    return {
      show_loading: false,
      articles: [],
    };
  },
  mounted() {
    this.getArticles();
  },
  methods: {
    getArticles() {
      this.show_loading = true;
      api
        .post(api.route.get.articles)
        .then((res) => {
          let status = res.status;
          if (status) this.articles = res.data;
          this.show_loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
};
</script>
<style>
.news-img {
  border-radius: 5px 5px 0px 0px;
}
.news-container .bg-lighter {
  border-radius: 0px 0px 5px 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/HomeNews.vue